export default {
  // Login page
  login: {
    title: "مرحباً بعودتك",
    subtitle: "سجل دخولك إلى حسابك للمتابعة",
    developmentMode: "وضع التطوير: نقطة نهاية API هي",
    phoneOrEmail: "رقم الهاتف أو البريد الإلكتروني",
    password: "كلمة المرور",
    fieldRequired: "هذا الحقل مطلوب",
    rememberMe: "تذكرني",
    forgotPassword: "نسيت كلمة المرور؟",
    signIn: "تسجيل الدخول",
    noAccount: "ليس لديك حساب؟",
    createAccount: "إنشاء حساب"
  },

  // Signup page
  signup: {
    title: "إنشاء حساب",
    subtitle: "انضم إلينا وابدأ في إدارة شحناتك",
    fullName: "الاسم الكامل",
    emailAddress: "عنوان البريد الإلكتروني",
    phoneNumber: "رقم الهاتف",
    confirmPassword: "تأكيد كلمة المرور",
    forgotPassword: "نسيت كلمة المرور؟",
    createAccount: "إنشاء حساب",
    haveAccount: "لديك حساب بالفعل؟",
    signIn: "تسجيل الدخول"
  },

  // Forgot password page
  forgotPassword: {
    title: "نسيت كلمة المرور",
    subtitle: "أدخل عنوان بريدك الإلكتروني وسنرسل لك رمز إعادة التعيين",
    emailAddress: "عنوان البريد الإلكتروني",
    sendResetCode: "إرسال رمز إعادة التعيين",
    rememberPassword: "تتذكر كلمة المرور؟",
    signIn: "تسجيل الدخول",
    noAccount: "ليس لديك حساب؟",
    createAccount: "إنشاء حساب",
    
    // Success state
    successTitle: "تحقق من بريدك الإلكتروني",
    successSubtitle: "لقد أرسلنا رمز إعادة تعيين كلمة المرور إلى عنوان رقم تلفونك على واتس اب او الى بريدك الإلكتروني",
    resetCodeSent: "تم إرسال رمز إعادة التعيين!",
    checkEmailMessage: "يرجى التحقق من بريدك الإلكتروني للحصول على رمز إعادة تعيين كلمة المرور واتباع التعليمات لإعادة تعيين كلمة المرور.",
    backToLogin: "العودة إلى تسجيل الدخول",
    tryDifferentEmail: "جرب بريد إلكتروني مختلف"
  },

  // Confirm forgotten password page
  confirmForgottenPassword: {
    title: "إعادة تعيين كلمة المرور",
    subtitle: "أدخل كلمة المرور الجديدة لإكمال عملية إعادة التعيين",
    newPassword: "كلمة المرور الجديدة",
    confirmNewPassword: "تأكيد كلمة المرور الجديدة",
    resetPassword: "إعادة تعيين كلمة المرور",
    successMessage: "تم إعادة تعيين كلمة المرور بنجاح! يرجى تسجيل الدخول بكلمة المرور الجديدة."
  },

  // Confirm OTP page
  confirmOtp: {
    title: "تحقق من حسابك",
    subtitle: "لقد أرسلنا رمز التحقق إلى",
    enterCode: "أدخل رمز التحقق",
    codeInstructions: "أدخل رمز التحقق المكون من 6 أرقام المرسل إلى عنوان بريدك الإلكتروني.",
    verifyAccount: "تحقق من الحساب",
    resendCode: "إعادة إرسال الرمز",
    backToLogin: "العودة إلى تسجيل الدخول"
  },

  // Common validation messages
  validation: {
    fillAllFields: "يرجى ملء جميع الحقول",
    passwordsNotMatch: "كلمات المرور غير متطابقة",
    passwordTooShort: "يجب أن تكون كلمة المرور 6 أحرف على الأقل",
    invalidEmail: "يرجى إدخال عنوان بريد إلكتروني صحيح",
    enterEmail: "يرجى إدخال عنوان بريدك الإلكتروني",
    enterVerificationCode: "يرجى إدخال رمز التحقق",
    invalidVerificationCode: "يرجى إدخال رمز تحقق صحيح"
  },

  // Common error messages
  errors: {
    resetCodeFailed: "فشل في إرسال رمز إعادة التعيين. يرجى المحاولة مرة أخرى.",
    unexpectedError: "حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى لاحقاً.",
    verificationFailed: "فشل التحقق. يرجى التحقق من الرمز والمحاولة مرة أخرى.",
    resetPasswordFailed: "فشل في إعادة تعيين كلمة المرور. يرجى المحاولة مرة أخرى.",
    invalidCredentials: "البريد الإلكتروني/الهاتف أو كلمة المرور غير صحيحة. يرجى التحقق من بيانات الاعتماد والمحاولة مرة أخرى.",
    accountBanned: "تم تعليق حسابك. يرجى الاتصال بالدعم للحصول على المساعدة.",
    confirmOTP: "يرجى التحقق من حسابك أولاً. تحقق من بريدك الإلكتروني للحصول على رمز التحقق.",
    loginFailed: "فشل تسجيل الدخول. يرجى المحاولة مرة أخرى.",
    networkError: "خطأ في الشبكة. يرجى التحقق من اتصالك والمحاولة مرة أخرى."
  }
};
